var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var PosData = require("./../../abstract/posData.js");

var RoutingVertexData = function(pos, net) {
    var self = this;
    this.makeObservableTreeNode();

    this.addPos(pos);

    this.net = this.value("net", false);

    if(net !== undefined) this.net(net);
};
lib_core.mixin(RoutingVertexData, lib_core.ObservableTreeNode, PosData);
lib_core.JsonParser.registerClass(RoutingVertexData, "RoutingVertexData");

module.exports = RoutingVertexData;

RoutingVertexData.prototype.toString = function () {
    return this.pos().toString();
};

RoutingVertexData.prototype.getConnectedSegments = function () {
    return this.parent().vtxConSegMap.get(this) || new lib_core.Collections.HashSet();
};

RoutingVertexData.prototype.replaceBy = function (other) {
    var self = this;
    this.getConnectedSegments().forEach(function (seg) {
        if(seg.startVertex() === self) seg.startVertex(other);
        else if(seg.endVertex() === self) seg.endVertex(other);
        else console.error("This should not happen");
    });
};
